"use client";

import { createContext, useContext } from "react";

interface VoiceUiContextValue {
  enabled: boolean;
}

const VoiceUiContext = createContext<VoiceUiContextValue>({ enabled: false });

export function VoiceUiProvider({ enabled, children }: { enabled: boolean; children: React.ReactNode }) {
  return <VoiceUiContext value={{ enabled }}>{children}</VoiceUiContext>;
}

export function useVoiceUiEnabled(): boolean {
  return useContext(VoiceUiContext).enabled;
}
